import { useState, useRef, useEffect } from "react";

export const useTranslatedPlaceholder = (originalPlaceholder?: string) => {
  const [translatedPlaceholder, setTranslatedPlaceholder] =
    useState(originalPlaceholder);
  const preservedRef = useRef<string | undefined>(originalPlaceholder);

  useEffect(() => {
    if (!originalPlaceholder) return;

    const checkForTranslation = () => {
      const placeholderElements = document.querySelectorAll(
        ".custom-select__placeholder",
      );
      for (const element of placeholderElements) {
        if (element.innerHTML.includes("<!--wovn-src:")) {
          const textContent =
            element.textContent ||
            element.innerHTML.replaceAll(/<!--wovn-src:[^-->]+-->/g, "");
          if (textContent !== originalPlaceholder && textContent.trim()) {
            preservedRef.current = textContent;
            setTranslatedPlaceholder(textContent);
          }
        }
      }
    };

    checkForTranslation();

    const observer = new MutationObserver(() => {
      checkForTranslation();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true,
    });

    return () => observer.disconnect();
  }, [originalPlaceholder]);

  return translatedPlaceholder || originalPlaceholder;
};
